// import React from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Navigate, useNavigate, useParams } from 'react-router-dom';
// import {buyCourse} from "../services/operations/studentFeaturesAPI";

// function CourseDetails(props) {

//     const {token} = useSelector((state)=>state.auth);
//     const {user} = useSelector((state)=>state.profile);
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const {courseId} = useParams();

//     const handleBuyCourse = async() => {
//         if(token)
//         {
//             buyCourse(token,[courseId],user,navigate,dispatch);
//             return;
//         }
//     }

//     return (
//         <div>
//             <button onClick={
//                 ()=>{
//                     handleBuyCourse()
//                 }
//             } className='text-richblack-50'>Buy now</button>
//         </div>
//     );
// }

// export default CourseDetails;

// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Navigate, useNavigate, useParams } from 'react-router-dom';
// import {buyCourse} from "../services/operations/studentFeaturesAPI";
// import GetAvgRating from "../utils/avgRating"
// import Error from "./Error";
// import RatingStars from "../components/common/RatingStars"
// import Footer from "../components/common/Footer"
// import CourseDetailsCard from '../components/core/course/CourseDetailsCard';
// import { BiInfoCircle } from "react-icons/bi"
// import { HiOutlineGlobeAlt } from "react-icons/hi"
// // import {ReactMarkdown} from "react-markdown/lib/react-markdown";
// import { formatDate } from "../services/formatDate"
// import CourseAccordionBar from '../components/core/course/CourseAccordionBar';
// import ConfirmationModal from "../components/common/ConfirmationModal"

// function CourseDetails(props) {

//     const {token} = useSelector((state)=>state.auth);
//     const {user} = useSelector((state)=>state.profile);
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const {courseId} = useParams();
//     const handleBuyCourse = async() => {
//         if(token)
//         {
//             buyCourse(token,[courseId],user,navigate,dispatch);
//             return;
//         }
//     }
//   const { loading } = useSelector((state) => state.profile)

//   const { paymentLoading } = useSelector((state) => state.course)

//   const [response, setResponse] = useState(null)

//   const [confirmationModal, setConfirmationModal] = useState(null)

//     const [avgReviewCount, setAvgReviewCount] = useState(0)
//     useEffect(() => {
//       const count = GetAvgRating(response?.data?.courseDetails.ratingAndReviews)
//       setAvgReviewCount(count)
//     }, [response])

//     const [isActive, setIsActive] = useState(Array(0))
//   const handleActive = (id) => {
//     // console.log("called", id)
//     setIsActive(
//       !isActive.includes(id)
//         ? isActive.concat([id])
//         : isActive.filter((e) => e !== id)
//     )
//   }

//     const [totalNoOfLectures, setTotalNoOfLectures] = useState(0)
//   useEffect(() => {
//     let lectures = 0
//     response?.data?.courseDetails?.courseContent?.forEach((sec) => {
//       lectures += sec.subSection.length || 0
//     })
//     setTotalNoOfLectures(lectures)
//   }, [response])

//     // if (loading || !response) {
//     //     return (
//     //       <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
//     //         <div className="spinner"></div>
//     //       </div>
//     //     )
//     //   }
//     //   if (!response.success) {
//     //     return <Error/>
//     //   }

//     const {
//         _id: course_id,
//         courseName,
//         courseDescription,
//         thumbnail,
//         price,
//         whatYouWillLearn,
//         courseContent,
//         ratingAndReviews,
//         instructor,
//         studentsEnroled,
//         createdAt,
//       } = response.data?.courseDetails

//     if (paymentLoading) {
//         // console.log("payment loading")
//         return (
//           <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
//             <div className="spinner"></div>
//           </div>
//         )
//       }
//     // return (
//         // <div>
//         //     <button onClick={
//         //         ()=>{
//         //             handleBuyCourse()
//         //         }
//         //     } className='text-richblack-50'>Buy now</button>
//         // </div>
//     // );
//     return (
//         <>
//           <div className={`relative w-full bg-richblack-800`}>
//             {/* Hero Section */}
//             <div className="mx-auto box-content px-4 lg:w-[1260px] 2xl:relative ">
//               <div className="mx-auto grid min-h-[450px] max-w-maxContentTab justify-items-center py-8 lg:mx-0 lg:justify-items-start lg:py-0 xl:max-w-[810px]">
//                 <div className="relative block max-h-[30rem] lg:hidden">
//                   <div className="absolute bottom-0 left-0 h-full w-full shadow-[#161D29_0px_-64px_36px_-28px_inset]"></div>
//                   <img
//                     src={thumbnail}
//                     alt="course thumbnail"
//                     className="aspect-auto w-full"
//                   />
//                 </div>
//                 <div
//                   className={`z-30 my-5 flex flex-col justify-center gap-4 py-5 text-lg text-richblack-5`}
//                 >
//                   <div>
//                     <p className="text-4xl font-bold text-richblack-5 sm:text-[42px]">
//                       {courseName}
//                     </p>
//                   </div>
//                   <p className={`text-richblack-200`}>{courseDescription}</p>
//                   <div className="text-md flex flex-wrap items-center gap-2">
//                     <span className="text-yellow-25">{avgReviewCount}</span>
//                     <RatingStars Review_Count={avgReviewCount} Star_Size={24} />
//                     <span>{`(${ratingAndReviews.length} reviews)`}</span>
//                     <span>{`${studentsEnroled.length} students enrolled`}</span>
//                   </div>
//                   <div>
//                     <p className="">
//                       Created By {`${instructor.firstName} ${instructor.lastName}`}
//                     </p>
//                   </div>
//                   <div className="flex flex-wrap gap-5 text-lg">
//                     <p className="flex items-center gap-2">
//                       {" "}
//                       <BiInfoCircle /> Created at {formatDate(createdAt)}
//                     </p>
//                     <p className="flex items-center gap-2">
//                       {" "}
//                       <HiOutlineGlobeAlt /> English
//                     </p>
//                   </div>
//                 </div>
//                 <div className="flex w-full flex-col gap-4 border-y border-y-richblack-500 py-4 lg:hidden">
//                   <p className="space-x-3 pb-4 text-3xl font-semibold text-richblack-5">
//                     Rs. {price}
//                   </p>
//                   <button className="yellowButton" onClick={handleBuyCourse}>
//                     Buy Now
//                   </button>
//                   <button className="blackButton">Add to Cart</button>
//                 </div>
//               </div>
//               {/* Courses Card */}
//               <div className="right-[1rem] top-[60px] mx-auto hidden min-h-[600px] w-1/3 max-w-[410px] translate-y-24 md:translate-y-0 lg:absolute  lg:block">
//                 <CourseDetailsCard
//                   course={response?.data?.courseDetails}
//                   setConfirmationModal={setConfirmationModal}
//                   handleBuyCourse={handleBuyCourse}
//                 />
//               </div>
//             </div>
//           </div>
//           <div className="mx-auto box-content px-4 text-start text-richblack-5 lg:w-[1260px]">
//             <div className="mx-auto max-w-maxContentTab lg:mx-0 xl:max-w-[810px]">
//               {/* What will you learn section */}
//               <div className="my-8 border border-richblack-600 p-8">
//                 <p className="text-3xl font-semibold">What you'll learn</p>
//                 <div className="mt-5">
//                   {/* <ReactMarkdown>{whatYouWillLearn}</ReactMarkdown> */}
//                 </div>
//               </div>

//               {/* Course Content Section */}
//               <div className="max-w-[830px] ">
//                 <div className="flex flex-col gap-3">
//                   <p className="text-[28px] font-semibold">Course Content</p>
//                   <div className="flex flex-wrap justify-between gap-2">
//                     <div className="flex gap-2">
//                       <span>
//                         {courseContent.length} {`section(s)`}
//                       </span>
//                       <span>
//                         {totalNoOfLectures} {`lecture(s)`}
//                       </span>
//                       <span>{response.data?.totalDuration} total length</span>
//                     </div>
//                     <div>
//                       <button
//                         className="text-yellow-25"
//                         onClick={() => setIsActive([])}
//                       >
//                         Collapse all sections
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Course Details Accordion */}
//                 <div className="py-4">
//                   {courseContent?.map((course, index) => (
//                     <CourseAccordionBar
//                       course={course}
//                       key={index}
//                       isActive={isActive}
//                       handleActive={handleActive}
//                     />
//                   ))}
//                 </div>

//                 {/* Author Details */}
//                 <div className="mb-12 py-4">
//                   <p className="text-[28px] font-semibold">Author</p>
//                   <div className="flex items-center gap-4 py-4">
//                     <img
//                       src={
//                         instructor.image
//                           ? instructor.image
//                           : `https://api.dicebear.com/5.x/initials/svg?seed=${instructor.firstName} ${instructor.lastName}`
//                       }
//                       alt="Author"
//                       className="h-14 w-14 rounded-full object-cover"
//                     />
//                     <p className="text-lg">{`${instructor.firstName} ${instructor.lastName}`}</p>
//                   </div>
//                   <p className="text-richblack-50">
//                     {instructor?.additionalDetails?.about}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <Footer />
//           {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
//         </>
//       )
// }

// export default CourseDetails;

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { buyCourse } from "../services/operations/studentFeaturesAPI";
import GetAvgRating from "../utils/avgRating";
import Error from "./Error";
import RatingStars from "../components/common/RatingStars";
import Footer from "../components/common/Footer";
import CourseDetailsCard from "../components/core/course/CourseDetailsCard";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineGlobeAlt } from "react-icons/hi";
// import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { formatDate } from "../services/formatDate";
import CourseAccordionBar from "../components/core/course/CourseAccordionBar";
import { fetchCourseDetails } from "../services/operations/courseDetailsAPI";
import ConfirmationModal from "../components/common/ConfirmationModal";

function CourseDetails(props) {
  const { token } = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.profile);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { courseId } = useParams();
  const [confirmationModal, setConfirmationModal] = useState(null);
  
  
  
  const handleBuyCourse = async () => {
    /*
      handleBuyCourse is used to handle the payment modal
      and also updated course and student details
    */
    if (token) {
      buyCourse(token, [courseId], user, navigate, dispatch);
      return;
    }
    /*
      If the user is not logged in then we will show and confirmation modal
      to navigate the user to login
    */
    setConfirmationModal({
      text1: "You are not logged in",
      text2: "Please login to purchase the course",
      btn1Text: "Login",
      btn2Text: "Cancel",
      btn1Handler: () => {navigate("/login")},
      btn2Handler: () => {
        setConfirmationModal(null);
      }
    })
  };
  const { loading } = useSelector((state) => state.profile);
  const { paymentLoading } = useSelector((state) => state.course);
  const [response, setResponse] = useState(null);
  const [avgReviewCount, setAvgReviewCount] = useState(0);

  useEffect(() => {
    // Calling fetchCourseDetails fucntion to fetch the details
    (async () => {
      try {
        const res = await fetchCourseDetails(courseId);
        // console.log("course details res: ", res)
        // console.log("Response: ",res);
        setResponse(res);
      } catch (error) {
        // console.log("Could not fetch Course Details");
      }
    })();
  }, [courseId]);

  useEffect(() => {
    // console.log("course details res: ", response);

    const count = GetAvgRating(response?.data[0]?.ratingAndReviews);
    // console.log("Response one: ", response);
    setAvgReviewCount(count);
  }, [response]);

  const [isActive, setIsActive] = useState(Array(0));
  const handleActive = (id) => {

    /*
      it takes id as input and append it in the array if
      the section is not open else it will remove it from the array
    */

    setIsActive(
      !isActive.includes(id)
        ? isActive.concat([id])
        : isActive.filter((e) => e !== id)
    );
  };


  const [totalNoOfLectures, setTotalNoOfLectures] = useState(0);
  useEffect(() => {
    /*
      totalNumber of lectures in an course
      data[0] is because there is a error in response?.data?.courseContent
      find why?
    */
    // console.log("Duration",response.data)
      let lectures = 0;
    // console.log("Response loop: ",response?.data)
    
    /*
      response?.data[0]?.courseContent it returns an array
    */
    response?.data[0]?.courseContent?.forEach((sec) => {
      lectures += sec.subSection.length || 0;
    });

    setTotalNoOfLectures(lectures);
  }, [response]);

  if (loading || !response) {
    return (
      <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
        {/* <div className="spinner flex justify-center items-center"></div> */}
        <div className='flex w-full h-screen justify-center items-center'>
            <div className='spinner'></div>
        </div>
      </div>
    );
  }
  //   console.log("Response: ", response.data);
  if (loading || !response) {
    return (
      <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
        {/* <div className="spinner flex justify-center items-center"></div> */}
        <div className='flex w-full h-screen justify-center items-center'>
                <div className='spinner'></div>
        </div>
      </div>
    );
  }
  if (!response.success) {
    return <Error />;
  }


  const {
    /*
      Fetching data from course details
    */
    course_id: _id,
    courseName,
    courseDescription,
    thumbnail,
    price,
    whatYouWillLearn,
    courseContent,
    ratingAndReviews,
    instructor,
    studentEnrolled,
    createdAt,
  } = response.data[0];


  // console.log("New repsonse",response.data[0]);

  if (paymentLoading) {
    /*
      
    */
    return (
      <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
        {/* <div className="spinner flex justify-center items-center"></div> */}
        <div className='flex w-full h-screen justify-center items-center'>
                <div className='spinner'></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={`relative w-full bg-richblack-800`}>
        {/* Hero Section */}
        <div className="mx-auto box-content px-4 lg:w-[1260px] 2xl:relative ">
          <div className="mx-auto grid min-h-[450px] max-w-maxContentTab justify-items-center py-8 lg:mx-0 lg:justify-items-start lg:py-0 xl:max-w-[810px]">
            <div className="relative block max-h-[30rem] lg:hidden">
              <div className="absolute bottom-0 left-0 h-full w-full shadow-[#161D29_0px_-64px_36px_-28px_inset]"></div>
              <img
                src={thumbnail}
                alt="course thumbnail"
                className="aspect-auto w-full"
              />
            </div>
            <div
              className={`z-30 my-5 flex flex-col justify-center gap-4 py-5 text-lg text-richblack-5`}>
              <div>
                <p className="text-4xl font-bold text-richblack-5 sm:text-[42px]">
                  {courseName}
                </p>
              </div>
              <p className={`text-richblack-200`}>{courseDescription}</p>
              <div className="text-md flex flex-wrap items-center gap-2">
                <span className="text-yellow-25">{avgReviewCount}</span>
                
                
                {/* Rating */}
                <RatingStars Review_Count={avgReviewCount} Star_Size={24} />
                
                {/* Rating and reviews */}
                <span>{`(${ratingAndReviews?.length} reviews)`}</span>
                
                {/* enrolled student */}
                <span>{`${studentEnrolled?.length} students enrolled`}</span>
              </div>
              <div>

                {/* Created By */}
                <p className="">
                  Created By {`${instructor.firstName} ${instructor.lastName}`}
                </p>
              </div>
              <div className="flex flex-wrap gap-5 text-lg">
                <p className="flex items-center gap-2">
                  {" "}
                  <BiInfoCircle /> Created at {formatDate(createdAt)}
                </p>
                <p className="flex items-center gap-2">
                  {" "}
                  <HiOutlineGlobeAlt /> English
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex w-full flex-col gap-4 border-y border-y-richblack-500 py-4 lg:hidden">
              <p className="space-x-3 pb-4 text-3xl font-semibold text-richblack-5">
                Rs. {price}
              </p>
              <button className="yellowButton" onClick={handleBuyCourse}>
                Buy Now
              </button>
              <button className="bg-richblack-700 text-richblack-50 rounded-md py-2">Add to Cart</button>
            </div>
          </div>

          {/* Courses Card */}
          <div className="right-[1rem] top-[60px] mx-auto hidden min-h-[600px] w-1/3 max-w-[410px] translate-y-24 md:translate-y-0 lg:absolute  lg:block">
            
            <CourseDetailsCard
              /*
                creates card component
                setConfirmationModal is sent in case the user is not logged in
                handleBuyCourse is sent in case the user is logged in
              */
              course={response?.data[0]}
              setConfirmationModal={setConfirmationModal}
              handleBuyCourse={handleBuyCourse}
            />

          </div>
        </div>
      </div>
      <div className="mx-auto box-content px-4 text-start text-richblack-5 lg:w-[1260px]">
        <div className="mx-auto max-w-maxContentTab lg:mx-0 xl:max-w-[810px]">
          {/* What will you learn section */}
          <div className="my-8 border border-richblack-600 p-8">
            <p className="text-3xl font-semibold">What you'll learn</p>
            <div className="mt-5">
              {/* <ReactMarkdown> */}
              <p>{whatYouWillLearn}</p>
              {/* </ReactMarkdown> */}
            </div>
          </div>

          {/* Course Content Section */}
          <div className="max-w-[830px] ">
            <div className="flex flex-col gap-3">
              <p className="text-[28px] font-semibold">Course Content</p>
              <div className="flex flex-wrap justify-between gap-2">
                <div className="flex gap-2">
                  <span>
                    {courseContent.length} {`section(s)`}
                  </span>
                  <span>
                    {totalNoOfLectures} {`lecture(s)`}
                  </span>
                  <span>{response.data?.totalDuration} total length</span>
                </div>
                <div>
                  <button
                    className="text-yellow-25"
                    onClick={() => setIsActive([])}>
                    Collapse all sections
                  </button>
                </div>
              </div>
            </div>

            {/* Course Details Accordion */}
            <div className="py-4">
              {courseContent?.map((course, index) => (
                <CourseAccordionBar
                  course={course}
                  key={index}
                  isActive={isActive}
                  handleActive={handleActive}
                />
              ))}
            </div>

            {/* Author Details */}
            <div className="mb-12 py-4">
              <p className="text-[28px] font-semibold">Author</p>
              <div className="flex items-center gap-4 py-4">
                <img
                  src={
                    instructor.image
                      ? instructor.image
                      : `https://api.dicebear.com/5.x/initials/svg?seed=${instructor.firstName} ${instructor.lastName}`
                  }
                  alt="Author"
                  className="h-14 w-14 rounded-full object-cover"
                />
                <p className="text-lg">{`${instructor.firstName} ${instructor.lastName}`}</p>
              </div>
              <p className="text-richblack-50">
                {instructor?.additionalDetails?.about}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
    </>
  );
}

export default CourseDetails;